import { EditTabsPattern } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'

import { ConfigData, HistoryTab, SettingsTab } from './tabs'

const tabs = [
  { component: <SettingsTab />, name: 'settings' },
  { component: <HistoryTab />, name: 'version' },
  { component: <ConfigData />, name: 'config' },
]

export const UserGrouping = () => {
  const { componentID, useUrl } = useComponentProvider()
  return (
    <EditTabsPattern
      defaultTab="settings"
      showTabs={!!componentID}
      tabs={tabs}
      urlParams={useUrl}
    />
  )
}
